const WarningIcon = (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 21h22L12 2 1 21z" />
      <path d="M12 16v-4" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="18" r="1" fill="white" />
    </svg>
  );
  
  export default WarningIcon;
  